import type { Organization } from "fhir/r5";

/**
 * Organization do tipo ecommerce: qualquer coding em type[] com code "ecommerce".
 * Não depende da ordem dos types (o primeiro coding pode ser outro código).
 */
export function isEcommerceOrganization(
  organization?: Organization,
): boolean {
  return Boolean(
    organization?.type?.some((type) =>
      type.coding?.some((coding) => coding.code?.toLowerCase() === "ecommerce"),
    ),
  );
}
